<template>
  <div class="plans">
    <va-card :title="$t('planAdd.title')">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo" v-slot="{ errors }">
                <va-input
                  v-model="name"
                  :label="$t('planAdd.forms.nameLabel')"
                  :placeholder="$t('planAdd.forms.namePlaceholder')"
                  :success="errors.length == 0 && name.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Preço" v-slot="{ errors }">
                <va-input
                  v-model="montante"
                  :label="$t('planAdd.forms.amountLabel')"
                  :placeholder="$t('planAdd.forms.amountPlaceholder')"
                  :success="errors.length == 0 && montante > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required|numeric" name="Duração" v-slot="{ errors }">
                <va-input
                  v-model="duracao"
                  type="number"
                  :label="$t('planAdd.forms.durationLabel')"
                  :placeholder="$t('planAdd.forms.durationPlaceholder')"
                  :success="errors.length == 0 && duracao > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div class="d-flex mt-3">
                <va-button
                  type="submit"
                  :disabled="loading"
                  color="success"
                  class="my-0">
                  {{ textSubmit }}
                </va-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
  name: 'plansAdd',
  components: {},
  methods: {
    onSubmit () {
      this.loading = true
      this.textSubmit = this.$t('forms.submitting')
      const parameters = {
        name: this.name,
        amount: this.amount,
        duration: this.duration,
      }
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($name: String!, $amount: numeric!, $duration: Int!) {
              insert_plan(objects: {amount: $amount, name: $name, duration: $duration}) {
                affected_rows
              }
            }
          `,
          variables: parameters,
        })
        .then(data => {
          this.loading = false
          this.textSubmit = this.$t('forms.submit')
          this.showToast(
            this.$t('toasts.successCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
              onComplete: () => this.$router.push({ name: 'plans' }),
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorCreate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      name: '',
      amount: 0,
      duration: 0,
      loading: false,
      textSubmit: this.$t('forms.submit'),
    }
  },
  computed: {
    duracao: {
      get () {
        return this.duration
      },
      set (value) {
        if (value >= 0 && value <= 365) {
          this.duration = value
        }
      },
    },
    montante: {
      get () {
        return this.amount
      },
      set (value) {
        if (value >= 0) {
          this.amount = value
        }
      },
    },
  },
}
</script>

<style lang="scss">
</style>
